import React, { useState } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { checkCurrentUser, CurrentUserCheck, Logger } from '@futrli/shared-services';

import { initLoggedInAnalyticsTracker } from '../core/setup';
import { hasPlatformEnableAnalyticsEnabled } from '../utils/flags';
import { getCurrentUser } from '../utils/user';

/**
 * Setup analytics tracker
 */
export const useAnalyticsTrackerInit = () => {
  const flags = useFlags();
  const isAnalyticsFlagEnabled = hasPlatformEnableAnalyticsEnabled(flags);
  const [areAnalyticsInitialised, setAreAnalyticsInitialised] = useState<boolean>(false);

  React.useEffect(() => {
    if (!isAnalyticsFlagEnabled || areAnalyticsInitialised) {
      return;
    }

    const initialiseAnalytics = async () => {
      const user = await getCurrentUser();
      let currentUser: CurrentUserCheck | null = null
      try {
        currentUser = await checkCurrentUser();
      }catch (e){
        Logger.error('Error during fetching current user')
      }
      await initLoggedInAnalyticsTracker(user, currentUser?.i_hash);
      setAreAnalyticsInitialised(true);
    };
    initialiseAnalytics();
  }, [isAnalyticsFlagEnabled, areAnalyticsInitialised]);
};
